import { getAxiosClient } from "../../axios-client";
import { OfferClientPreAcceptRequestBody, OfferClientPreAcceptResponse } from "./types";

const axiosClient = getAxiosClient();
export const offerClientPreAccept = async (body: OfferClientPreAcceptRequestBody) => {
    return await axiosClient.ax.post<OfferClientPreAcceptResponse>("/Offers/OfferClientPreAccept", body);
};

